import ApiService from "@/services/api.service";
import TokenService from "@/services/storage.service";

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    login: async function(email, password) {
        const requestData = {
            method: 'post',
            url: "/o/token",
            // url: "/api/login",
            data: {
                grant_type: 'password',
                username: email,
                password: password
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        }

        try {
            // console.log(requestData); alert(1);
            const response = await ApiService.customRequest(requestData)

            // console.log(response); alert(1);
            this.saveUserData(response.data.user);
            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader()

            ApiService.mount401Interceptor()

            return response.data
        } catch (error) {
            // alert('incomming...')
            // alert(error)
            // console.log(error.response);
            throw new AuthenticationError(error.response.status, error.response.data.message)
        }
    },

    resetPw: async function(email) {
        const requestData = {
            method: "post",
            url: "/p/resetpw",
            data: {
                email: email
            }
        }

        try {
            const response = await ApiService.customRequest(requestData);

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.message)
        }
    },

    refreshToken: async function () {
        const refreshToken = TokenService.getRefreshToken()

        const requestData = {
            method: 'post',
            url: "/o/token",
            data: {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader()

            return response.data.access_token
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    logout() {
        this.removeUserData();
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()

        ApiService.unmount401Interceptor()
    },

    getUserData(user_field) {
        return localStorage.getItem(user_field);
    },

    saveUserData(user_data) {
        localStorage.setItem('user_roles', user_data.user_roles);
        localStorage.setItem('user_id', user_data.user_id);
    },

    removeUserData() {
        localStorage.removeItem('user_roles');
        localStorage.removeItem('user_id');
    }
}

export default UserService

export { UserService, AuthenticationError }